import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const heroArticles = articles.filter((a) => a.isHot).slice(0, 3);

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 500);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % heroArticles.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const article = heroArticles[current];

  return (
    <section className="relative w-full h-[420px] md:h-[580px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover object-top transition-opacity duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col justify-end px-4 md:px-6 pb-12 md:pb-16">
        <div className="max-w-3xl">
          <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md mb-3 whitespace-nowrap">
            {article.category}
          </span>
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-3 leading-tight">
            {article.title}
          </h1>
          <p className="text-foreground-300 text-sm md:text-base max-w-xl mb-5 line-clamp-2">
            {article.description}
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <Link
              to={`/article/${article.slug}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg cursor-pointer transition-colors whitespace-nowrap"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <span>立即观看</span>
              <i className="ri-play-fill"></i>
            </Link>
            <div className="flex items-center gap-2 text-background-50 text-sm">
              <i className="ri-star-fill text-primary-400"></i>
              <span className="font-semibold">{article.rating}</span>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 mt-6">
          {heroArticles.map((_, index) => (
            <button
              key={index}
              onClick={() => goTo(index)}
              className={`h-2 rounded-full transition-all duration-300 cursor-pointer ${
                index === current ? 'w-8 bg-primary-500' : 'w-2 bg-background-50/50 hover:bg-background-50/80'
              }`}
              aria-label={`切换到第${index + 1}张`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}